export default __webpack_public_path__ + "static/media/grilled-chicken.b9bbf937.png";